export default __webpack_public_path__ + "a947bf020b26ea85daa17dfd2a1a17e902ab18ff/a6bf0ad36e700bb31f6714c905f959a1.png";